// extracted by mini-css-extract-plugin
export default {"root":"NotFoundPage_root__s+U1M","container":"NotFoundPage_container__vbt+K","cover":"NotFoundPage_cover__kgHTZ"};